import { addPluginNamespace } from "./i18n";
import type { PluginClientManifest } from "@/core/plugins/types";

/**
 * Register every plugin's i18n resource bundles so plugin screens resolve their
 * keys instead of rendering raw key paths (e.g. "platform.title", "field.headline").
 *
 * Plugins declare `i18nResources` ({ lang: { namespace: bundle } }) in their
 * client manifest. This runs once at startup (main.tsx), before the first render.
 * addPluginNamespace is idempotent, so re-invocation is harmless.
 */
export function loadPluginI18nNamespaces(manifests: readonly PluginClientManifest[]): void {
  for (const manifest of manifests) {
    const byLanguage = manifest.i18nResources;
    if (!byLanguage) continue;

    for (const [language, byNamespace] of Object.entries(byLanguage)) {
      for (const [namespace, resources] of Object.entries(byNamespace)) {
        addPluginNamespace(namespace, language, resources);
      }
    }
  }
}
